// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"64e82a51","453":"386cf522","732":"42575239","977":"bc38ba8a"}[chunkId] + ".chunk.js";
};